import React, { useEffect, useState } from "react";
import { withStripePayment } from "../../../../../common/with-stripe-payment";
import SubscriptionPaymentDetails from "./SubscriptionPaymentDetails";
import {
  createPaymentIntent,
  createSubscriptionPurchase,
  getAllCardsAction,
  getPaymentIntentAction,
  getTaxonomyAction,
  validateCouponCodeAction,
} from "../../../../../../redux/services/payments/paymentServices";
import { useDispatch, useSelector } from "react-redux";
import {
  baseRouteMaker,
  routes,
} from "../../../../../../constants/routeConsts";
import { useNavigate } from "react-router-dom";
import Spinner from "../../../../../common/spinner/Spinner";
import { toastService } from "../../../../../common/toast-messages/toast";
import { useStripe } from "@stripe/react-stripe-js";

const Subscription = withStripePayment(SubscriptionPaymentDetails);

const SubscriptionPaymentForm = () => {
  const stripe = useStripe();
  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [validateCouponCodeLoader, setValidateCouponCodeLoader] =
    useState(false);
  /* loading dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* navigation dependencies */
  const navigate = useNavigate();
  /* navigation dependencies */

  /* dialog dependencies */
  const [openPaymentConfirmationDialog, setOpenPaymentConfirmationDialog] =
    useState(false);
  /* dialog dependencies */

  const { loginDetails } = useSelector((state) => state.auth);
  const { selectedSubscriptionPlanDetails } = useSelector(
    (state) => state.serviceProviderSubscriptions
  );
  const { validateCouponData, tax } = useSelector((state) => state.payment);

  const [appliedCouponDetails, getAppliedCouponDetails] = useState(null);
  const [totalAmount, setTotalAmount] = useState(0);

  function calculateTotalPrice(price, taxes) {
    // Initialize the total price with the base price
    let totalPrice = Number(price);

    // Iterate through each tax in the array and add it to the total price
    taxes?.forEach((tax) => {
      if (tax.percentage && tax.percentage > 0) {
        // Calculate the tax amount based on the percentage
        const taxAmount = (price * tax.percentage) / 100;
        // Add the calculated tax amount to the total price
        totalPrice += taxAmount;
      }
    });

    // Return the final total price
    return totalPrice;
  }

  function calculateTotalTax(price, taxes) {

    let totalPrice = Number(price);
    let taxAmount = 0;

    taxes?.forEach((tax) => {
      if (tax.percentage && tax.percentage > 0) {
        taxAmount = (totalPrice * tax.percentage) / 100;
      }
    });
    return taxAmount;
  }

  useEffect(() => {
    let temp_amount = 0;
    if (
      appliedCouponDetails &&
      Object.keys(appliedCouponDetails)?.length !== 0
    ) {
      temp_amount = appliedCouponDetails?.total_amount?.toFixed(2);
    } else {
      temp_amount =
        selectedSubscriptionPlanDetails?.selectedPlan?.price.toFixed(2);
    }

    setTotalAmount(() => {
      if (tax.tax?.length) {
        return calculateTotalPrice(temp_amount, tax?.tax);
      } else {
        return temp_amount;
      }
    });
  }, [appliedCouponDetails]);

  /* function definition to create payment intent */
  const createPayment = async (
    newCardToken,
    selectedCard,
    resetDefaultFields,
    pay_using_wallet_points
  ) => {
    const payment_method = selectedCard ? selectedCard : newCardToken?.card?.id;

    const dataToBeSent = {
      currency: selectedSubscriptionPlanDetails?.selectedPlan?.currency,
      subscription_plan_id:
        selectedSubscriptionPlanDetails?.subscription_plan_id,
      event_type: selectedSubscriptionPlanDetails?.event_type,
      payment_method: payment_method,
      customer: loginDetails.customer_stripe_token,
      new_card: newCardToken?.id ? true : false,
      token_id: newCardToken?.id || null,
    };

    let temp_discount_amount = 0;

    if (validateCouponData && Object.keys(validateCouponData)?.length !== 0) {
      const temp_price = selectedSubscriptionPlanDetails?.selectedPlan?.price;
      const discount_percent =
        validateCouponData?.discount_coupon?.discount_percent;
      const discount_amount =
        validateCouponData?.discount_coupon?.discount_amount;

      switch (validateCouponData?.discount_coupon?.discount_type) {
        case "PERCENTAGE":
          temp_discount_amount = (temp_price * discount_percent) / 100;
          break;
        case "AMOUNT":
          temp_discount_amount = discount_amount;
          break;

        default:
          break;
      }
    }

    const temp_wallet_balance = Number(loginDetails?.wallet_balance);
    let selected_plan_price = Number(
      selectedSubscriptionPlanDetails?.selectedPlan?.price -
        temp_discount_amount
    );

    selected_plan_price = calculateTotalPrice(selected_plan_price, tax?.tax);

    dataToBeSent["amount"] = selected_plan_price;

    if (
      (pay_using_wallet_points && temp_wallet_balance >= selected_plan_price) ||
      selected_plan_price <= 0
    ) {
      createSubscriptionOrder(
        resetDefaultFields,
        null,
        pay_using_wallet_points
      );
    } else {
      if (pay_using_wallet_points)
        dataToBeSent["amount"] = selected_plan_price - temp_wallet_balance;
      dispatch(createPaymentIntent(dataToBeSent, setSubmitLoader)).then(
        (apiRes) => {
          confirmCardPayment(
            resetDefaultFields,
            apiRes,
            pay_using_wallet_points,
            payment_method
          );
          // previously we used to create subscription order here
        }
      );
    }
  };
  /* function definition to create payment intent */

  /* fuction definition to confirm card payment */
  const confirmCardPayment = async (
    resetDefaultFields,
    paymentIntentResponse,
    pay_using_wallet_points,
    payment_method
  ) => {
    if (paymentIntentResponse && paymentIntentResponse.id) {
      if (paymentIntentResponse.status === "requires_action") {
        try {
          const confirmData = await stripe.confirmCardPayment(
            paymentIntentResponse.client_secret,
            {
              payment_method: payment_method,
            }
          );
          if (confirmData.paymentIntent) {
            const dataToBeSent = {
              paymentIntentId: confirmData.paymentIntent.id,
            };
            dispatch(
              getPaymentIntentAction(dataToBeSent, setSubmitLoader)
            ).then((apiRes) => {
              handleStripeResponse(
                resetDefaultFields,
                apiRes,
                pay_using_wallet_points
              );
            });
          } else {
            toastService.error(confirmData?.error?.message);
            setSubmitLoader(false);
          }
        } catch (e) {
          toastService.error("Payment failed :" + e.message);
          setSubmitLoader(false);
        }
      } else {
        handleStripeResponse(
          resetDefaultFields,
          paymentIntentResponse,
          pay_using_wallet_points
        );
      }
    }
  };
  /* fuction definition to confirm card payment */

  /* function definition to check the payment intent status */
  const handleStripeResponse = (
    resetDefaultFields,
    paymentIntentResponse,
    pay_using_wallet_points
  ) => {
    if (
      paymentIntentResponse.status === "succeeded" ||
      paymentIntentResponse.status === "processing"
    ) {
      createSubscriptionOrder(
        resetDefaultFields,
        paymentIntentResponse,
        pay_using_wallet_points
      );
    }
    if (paymentIntentResponse.status === "requires_payment_method") {
      toastService.error("Payment failed, please try again later");
      setSubmitLoader(false);
    }
  };
  /* function definition to check the payment intent status */

  /* function definition to create subscription order */
  const createSubscriptionOrder = async (
    resetDefaultFields,
    paymentIntentResponse,
    pay_using_wallet_points
  ) => {
    // Take subscription plan details
    const dataToBeSent = {
      type: "main",
      parent_subscription_id: null,
      addon_logins: 0,
      plan_id: selectedSubscriptionPlanDetails?.subscription_plan_id,
      payment_intent_id: paymentIntentResponse
        ? paymentIntentResponse?.id
        : null,
      currency: selectedSubscriptionPlanDetails?.selectedPlan?.currency,
      duration: selectedSubscriptionPlanDetails?.selectedPlan?.duration,
      duration_unit:
        selectedSubscriptionPlanDetails?.selectedPlan?.duration_unit,
      user_ids_to_remove : selectedSubscriptionPlanDetails?.user_ids_to_remove || null
    };

    let temp_discount_amount = 0;

    if (validateCouponData && Object.keys(validateCouponData)?.length !== 0) {
      const temp_price = selectedSubscriptionPlanDetails?.selectedPlan?.price;
      const discount_percent =
        validateCouponData?.discount_coupon?.discount_percent;
      const discount_amount =
        validateCouponData?.discount_coupon?.discount_amount;

      switch (validateCouponData?.discount_coupon?.discount_type) {
        case "PERCENTAGE":
          temp_discount_amount = (temp_price * discount_percent) / 100;
          break;
        case "AMOUNT":
          temp_discount_amount = discount_amount;
          break;

        default:
          break;
      }

      dataToBeSent["coupon_discount"] = temp_discount_amount || 0;

      dataToBeSent["discount_coupon"] = {
        _id: validateCouponData?.discount_coupon?._id,
        coupon_code: validateCouponData?.discount_coupon?.coupon_code,
        coupon_name: validateCouponData?.discount_coupon?.coupon_name,
      };
      // validateCouponData?.discount_coupon?.coupon_code || null;
    }

    const temp_wallet_balance = Number(loginDetails?.wallet_balance);
    let selected_plan_price = Number(
      selectedSubscriptionPlanDetails?.selectedPlan?.price -
        temp_discount_amount
    );

    selected_plan_price = calculateTotalPrice(selected_plan_price, tax?.tax);

    dataToBeSent["total_amount"] = selected_plan_price;
    dataToBeSent["subtotal_amount"] = Number(
      selectedSubscriptionPlanDetails?.selectedPlan?.price -
        temp_discount_amount
    );
    // Tax calculation
    const temp_tax_amount = calculateTotalTax(Number(selectedSubscriptionPlanDetails?.selectedPlan?.price - temp_discount_amount), tax?.tax);
    dataToBeSent["tax_amount"] = temp_tax_amount >= 0 ? Number(temp_tax_amount?.toFixed(2)) : 0
    dataToBeSent["tax_applied"] = tax?.tax.map((item) => ({
      name: item.name,
      percentage: item.percentage,
      amount: temp_tax_amount >= 0 ? Number(temp_tax_amount?.toFixed(2)) : 0
    }));

    if (pay_using_wallet_points) {
      if (temp_wallet_balance >= selected_plan_price) {
        if (selected_plan_price < 0) {
          dataToBeSent["charged_from_wallet"] = 0;
          dataToBeSent["charged_from_stripe"] = 0;
          dataToBeSent["total_amount"] = 0;
          dataToBeSent["subtotal_amount"] = 0;
        } else {
          dataToBeSent["charged_from_wallet"] = selected_plan_price;
          dataToBeSent["charged_from_stripe"] = 0;
        }
      } else {
        dataToBeSent["charged_from_wallet"] = temp_wallet_balance;
        dataToBeSent["charged_from_stripe"] =
          selected_plan_price - temp_wallet_balance;
      }
    } else {
      if (selected_plan_price < 0) {
        dataToBeSent["charged_from_wallet"] = 0;
        dataToBeSent["charged_from_stripe"] = 0;
        dataToBeSent["total_amount"] = 0;
        dataToBeSent["subtotal_amount"] = 0;
      } else {
        dataToBeSent["charged_from_stripe"] = selected_plan_price;
        dataToBeSent["charged_from_wallet"] = 0;
      }
    }

    console.log(dataToBeSent,'dataToBeSent')

    dispatch(
      createSubscriptionPurchase(
        dataToBeSent,
        setSubmitLoader,
        setOpenPaymentConfirmationDialog,
        resetDefaultFields
      )
    );
  };
  /* function definition to create subscription order */

  /* load initial card dependencies - get data of previously used card */
  useEffect(() => {
    if (
      Object.keys(selectedSubscriptionPlanDetails)?.length === 0 ||
      selectedSubscriptionPlanDetails === null ||
      selectedSubscriptionPlanDetails === undefined
    ) {
      navigate(baseRouteMaker(routes.DASHBOARD));
    }
    dispatch(getAllCardsAction(setLoading));
    dispatch(getTaxonomyAction(setLoading));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  /* load initial card dependencies - get data of previously used card */

  const onValidateCouponCode = (coupon_code, setCouponCodeMessage) => {
    if (
      coupon_code &&
      coupon_code !== null &&
      coupon_code !== "" &&
      coupon_code !== undefined
    ) {
      const dataToBeSent = {
        discount_coupon: coupon_code,
        event_id: selectedSubscriptionPlanDetails?.subscription_plan_id,
        event_type: selectedSubscriptionPlanDetails?.event_type,
      };
      dispatch(
        validateCouponCodeAction(
          dataToBeSent,
          setValidateCouponCodeLoader,
          setCouponCodeMessage
        )
      );
    }
  };

  return loading ? (
    <Spinner />
  ) : (
    Object.keys(selectedSubscriptionPlanDetails)?.length !== 0 &&
      selectedSubscriptionPlanDetails !== null &&
      selectedSubscriptionPlanDetails !== undefined && (
        <Subscription
          submitLoader={submitLoader}
          createPayment={createPayment}
          openPaymentConfirmationDialog={openPaymentConfirmationDialog}
          setOpenPaymentConfirmationDialog={setOpenPaymentConfirmationDialog}
          validateCouponCode={onValidateCouponCode}
          validateCouponCodeLoader={validateCouponCodeLoader}
          showPayUsingWalletPointsCheckbox={true}
          applyCouponCode={true}
          getAppliedCouponDetails={getAppliedCouponDetails}
          totalAmount={totalAmount}
        />
      )
  );
};

export default React.memo(SubscriptionPaymentForm);
